export default __webpack_public_path__ + "static/media/macchinarioLogo.5bb6d8c6.png";